export default {
  title: 'Business Information',
  form: {},
  buttons: {
    save: 'Save',
  },
  toasts: {
    success: 'Successfully saved your information.',
  },
};
